import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hero-web-wrapper-layout',
  templateUrl: './web-wrapper-layout.component.html',
  styleUrls: ['./web-wrapper-layout.component.scss'],
})
export class WebWrapperLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
